import axios from "@/utils/axios";

export function couponActiveDetail(params: object) {
  return axios.post('/api/gateway/app/front/share/detail', params);
}
export function getGt4Captcha(params: object) {
  return axios.post('/api/gateway/app/front/share/initVerifyCaptcha', params);
}

export function getVerifyCode(params: object) {
  const config = {
    headers: {
      language: 'en',
      serviceId: 'h5',
    }
  }
  return axios.post('/api/gateway/app/front/share/verifyCode', params, config);
}

export function loginAndSend(params: object) {
  return axios.post('/api/gateway/app/front/share/coupon/loginAndSend', params);
}


// 券列表
let couponList = function (params: object) {
  // return axios.post('/activity/front/receive/center/couponList', params);
  return axios.post("/activity/v1/receiveCouponCenter/couponList", params);
};
//发券
let sendCoupon = function (params: object) {
  // return axios.post('/activity/front/receive/center/sendCoupon', params);
  return axios.post("/activity/v1/receiveCouponCenter/sendCoupon", params);
};
//领券
let gainCoupon = function (params: object) {
  return axios.post("/activity/private/gainCoupon", params);
};
//黑海转增礼
let forwardBlackMemberGiftCoupon = function (params: object) {
  return axios.post(
    "/activity/v1/receiveCouponCenter/forwardBlackMemberGiftCoupon",
    params
  );
};

//app 券包 未使用
const getCouponList = function (marker: string = "") {
  const params = {
    limit: 10,
    marker,
  };
  return axios.post("/app/card/getCouponList", params);
};

//app 券包已使用
const getUsedCouponList = function (marker: string = "") {
  const params = {
    limit: 10,
    marker,
  };
  return axios.post("/app/card/getUsedCouponList", params);
};
//app 券包已过期
const getExpiredCouponList = function (marker: string = "") {
  const params = {
    limit: 10,
    marker,
  };
  return axios.post("/app/card/getExpiredCouponList", params);
};
//app 券包 数量
const getCouponNum = function (status: number) {
  const params = {
    status,
  };
  return axios.post("/app/card/getCouponNum", params);
};
// app 券详情
const getCouponByCode = function (couponCode: string) {
  const params = {
    couponCode,
  };
  return axios.post("/app/card/getCouponByCode", params);
};
// app 券分享连接
const getCouponShareLink = function (couponCode: string) {
  const params = {
    couponCode,
  };
  return axios.post("/app/card/getCouponShareLink", params);
};
// app 券分享连接
const addCard = function (cardId: string) {
  const params = {
    code: cardId,
    country: "CN",
  };
  return axios.post("/app/coupon/bindCoupon", params);
};

//请求微信太阳码
const GetQrcode = function (params: { wxParam?: object; scene?: string }): any {
  return axios.post(
    "/activity/v1/receiveCouponCenter/getWxAppletQrCode",
    params
  );
};

export {
  gainCoupon,
  couponList,
  sendCoupon,
  getCouponList,
  getUsedCouponList,
  getExpiredCouponList,
  getCouponNum,
  getCouponByCode,
  getCouponShareLink,
  addCard,
  forwardBlackMemberGiftCoupon,
  GetQrcode,
};
